export const ONCE = 'ONCE';
export const DAILY = 'DAILY';
export const WEEKLY = 'WEEKLY';
export const MONTHLY = 'MONTHLY';
export const SEMI_ANNUALLY = 'SEMI-ANNUALLY';
export const ANNUALLY = 'ANNUALLY';
export const SELECTIVELY = 'SELECTIVELY';

export const WRITE_OFF_OPTIONS = {
  [DAILY]: {
    periodicity: DAILY,
  },
  [WEEKLY]: {
    periodicity: WEEKLY,
  },
  [MONTHLY]: {
    periodicity: MONTHLY,
  },
  [SEMI_ANNUALLY]: {
    periodicity: SEMI_ANNUALLY,
  },
  [ANNUALLY]: {
    periodicity: ANNUALLY,
  },
};

export const PERIODICITY_MAP = {
  [DAILY]: {
    description: 'common.daily',
    periodicity: DAILY,
  },
  [WEEKLY]: {
    description: 'common.weekly',
    periodicity: WEEKLY,
  },
  [MONTHLY]: {
    description: 'common.monthly',
    periodicity: MONTHLY,
  },
  [SEMI_ANNUALLY]: {
    description: 'common.semi-annually',
    periodicity: SEMI_ANNUALLY,
  },
  [ANNUALLY]: {
    description: 'common.annually',
    periodicity: ANNUALLY,
  },
};
